import PropTypes from 'prop-types'
// biome-ignore lint/correctness/noUnusedImports: Legacy
import React from 'react'
import colors from '../settings/colors'
import { hashString } from '../utils/data'

const Input = ({
  adminOnly,
  hideTable,
  isInvalid,
  neutral,
  options,
  showAsDiv,
  ...props
}) =>
  props.type === 'radio' ? (
    <div className="py-2 font-normal">
      {options.map((option) => (
        <label className="mr-6" key={option}>
          <input
            className="mr-1"
            {...props}
            defaultChecked={option === props.defaultValue}
            defaultValue={undefined}
            key={`${props.name}-${props.defaultValue}-${option}`}
            value={option}
          />
          {option}
        </label>
      ))}
    </div>
  ) : props.type === 'select' ? (
    <select
      className={`${
        neutral
          ? '-ml-2 font-semibold'
          : 'h-10 w-full rounded border bg-white px-3 py-2 text-gray-700 shadow hover:shadow-none focus:shadow-none focus:outline-none'
      } ${
        isInvalid
          ? `${colors.danger.border} ${colors.danger.focus}`
          : colors.default.focus
      }`}
      {...props}
      key={`${props.name}-${
        props.defaultValue || props.defaultChecked
      }-${options.map((option) => option.value || option).join('')}`}
    >
      {options.map((option) => (
        <option
          disabled={option.disabled}
          key={`${props.name}-${(
            typeof option === 'string' ? option : option.value
          ).toString()}`}
          value={option.value !== undefined ? option.value : option}
        >
          {option.label || option}
        </option>
      ))}
    </select>
  ) : props.type === 'textarea' ? (
    <textarea
      className={`h-10 h-20 w-full rounded border px-3 py-2 shadow hover:shadow-none focus:shadow-none focus:outline-none ${
        isInvalid
          ? `${colors.danger.border} ${colors.danger.focus}`
          : colors.default.focus
      }`}
      {...props}
      key={`${props.name}-${hashString(props.defaultValue)}}`}
    />
  ) : showAsDiv ? (
    <div className="py-2 font-normal">
      {(props.type === 'datetime-local' || props.type === 'date') &&
      props.defaultValue
        ? new Date(props.defaultValue).toLocaleString()
        : props.defaultValue || '–'}
    </div>
  ) : (
    <input
      className={`${
        props.type !== 'checkbox' ? 'w-full border shadow' : ''
      } rounded px-3 py-2 hover:shadow-none focus:shadow-none focus:outline-none ${
        isInvalid
          ? `${colors.danger.border} ${colors.danger.focus}`
          : colors.default.focus
      }`}
      {...props}
      key={`${props.name}-${props.defaultValue || props.defaultChecked}`}
    />
  )

Input.propTypes = {
  adminOnly: PropTypes.bool,
  hideTable: PropTypes.bool,
  isInvalid: PropTypes.bool,
  options: PropTypes.array,
  neutral: PropTypes.bool,
  type: PropTypes.string.isRequired
}

export default Input
